<template>
  <!-- <div class="MBlock" :class="{ NotPublished: !card.visible }" @click="goTo('card', { id: card.id })" v-for="card in cards"> -->
  <div class="UsersSwitcher" v-if="showSwitcher">
    <a href="#" v-show="isSwitcherLink('visible')" @click.prevent="switchTo('visible')">Опубликованные</a>
    <span v-show="!isSwitcherLink('visible')">Опубликованные</span>
    <a href="#" v-show="isSwitcherLink('hidden')" @click.prevent="switchTo('hidden')">В разработке</a>
    <span v-show="!isSwitcherLink('hidden')">В разработке</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: {
    show: String,
  },
  methods: {
    isSwitcherLink(type) {
      return this.show != type;
    },
    switchTo(newType) {
      this.$emit('switchTo', newType);
    },
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
    showSwitcher() {
      return this.currentUser.role == 'admin' || this.currentUser.role == 'moderator';
    },
  },
};
</script>
